<template>
  <div class="home">
    <ImageUploader @send-image-hrefs="setImageHref" />
  </div>
</template>

<script>
// @ is an alias to /src
import ImageUploader from '@/components/ImageUploader.vue'
import router from "@/router";

export default {
  name: 'Home',
  components: {
    ImageUploader
  },
  data: () => ({
    'sourceImageHref': null,
    'targetImageHref': null,
  }),
  methods: {
    setImageHref(imageHref) {
      router.push({
        name: 'Viewer',
        params: {
          sourceImageHref: imageHref['sourceImageHref'],
          targetImageHref: imageHref['targetImageHref']
        }
      });
      this.sourceImageHref = imageHref['sourceImageHref'];
      this.targetImageHref = imageHref['targetImageHref'];
    }
  }
}
</script>
